<template>
<section class="login_section">
    <div class="login-wrap">
        <div class="login-div">
            <div class="login-header"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-167"></div>
            <div class="login-form-div">
                <h1 class="heading-45">Welcome back</h1>
                <div class="text-block-201">Become your newself.</div>
                <div class="text-block-203">New user? <a href="/" class="link-12">Create an account <span class="text-span-182">-&gt;</span></a>
                </div>
                <div class="div-block-1041">
                    <div class="w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-5" @submit.prevent="onSubmit">
                            
                            <input class="login-user w-input" maxlength="256" v-model="password" name="email-or-phone" data-name="Email Address" placeholder="Enter password" type="password" id="email-or-phone" required>
                            
                            <input class="login-pw w-input" maxlength="256" v-model="repete_password" name="email-or-phone" data-name="Email Address" placeholder="Repete password" type="password" id="email-or-phone" required>

                            <button class="submit-button-6 w-button" :disabled="submitted" style="padding-top:12px">
                                <div v-if="submitted">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                        <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                        </circle>
                                    </svg>
                                </div>
                                <div v-else>
                                    <div class="">Reset</div>
                                </div>
                            </button>
                        </form>
                        <div class="w-form-done" v-if="success">
                            <svg class="form-warning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                            </svg>
                            <div>Password changed successfully.</div>
                        </div>
                        <div class="w-form-fail" style="display:block;" v-if="err">
                            <div>Link expired!</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:280px"></div>
</section>
</template>

<script>
export default {
    name: 'ResetPassword',
    props: ['baseUrl'],
    data() {
        return {
            password: '',
            repete_password: '',
            submitted: false,
            success: false,
            err: false,

        }
    },
    computed: {
        errorp() {
            if (this.password !== this.repete_password && this.repete_password !== '') {
                return true;
            }
            return false;
        }
    },
    methods: {
        onSubmit() {
            this.submitted = true;
            this.err = false;
            this.$axios.post(`${this.baseUrl}/api/password-reset`, {
                password: this.password,
                token: this.$route.params.token
            }).then(response => {
                if (response.data.status == 'success') {
                    this.success = true;
                    this.submitted = false;
                    this.$router.push('/home');
                } else {
                    this.submitted = false;
                    this.err = true;
                }
            });

        },
    },
}
</script>

<style scoped>
/* Only ever rendered behind v-if="success" — safe to force display here. */
.w-form-done {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    margin-top: 10px;
    background-color: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 6px;
    color: #92400e;
    text-align: left;
}

.form-warning-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    color: #f59e0b;
}
</style>
